module.exports = __webpack_public_path__ + "img/delete.c1e32c9b.svg";